import React, { useCallback, useEffect, useRef } from 'react';
import EmbeddedApp from '../components/EmbeddedApp';
import { tasksAppService } from '../services/api';

// Подія для меню ЕРП: непрочитані сповіщення задач (число) — миттєво, поки задачі відкриті
export const TASKS_BADGE_EVENT = 'replast:tasks-badge';

// «Задачі» — Synvolve Tasks (tasks/): окремий таск-менеджер, вбудовується в робочу область ЕРП.
// Бекенд видає одноразове посилання входу під поточним співробітником.
function TasksAppPage() {
  const originRef = useRef('');

  const getLoginUrl = useCallback(async () => {
    const res = await tasksAppService.login();
    originRef.current = new URL(res.data.url).origin;
    return res;
  }, []);

  // Лічильник приймаємо лише від сервісу задач (origin iframe)
  useEffect(() => {
    const onMessage = (e) => {
      if (e.origin !== originRef.current || e.data?.type !== 'replast-tasks-badges') return;
      window.dispatchEvent(new CustomEvent(TASKS_BADGE_EVENT, { detail: Number(e.data.unread) || 0 }));
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return <EmbeddedApp title="Задачі" getLoginUrl={getLoginUrl} errorText="Не вдалося відкрити задачі." />;
}

export default TasksAppPage;
